export const cmc7Regex = {
    IS_SPACE: /\s/g,
};
